import { FIXED_HEADER_ID, useTailwindBreakpoint } from '../../..';
import { Toast, useLayoutStateContext, useModalState } from '../../providers';

const MAIN_TAG = 'main';

export const getToastAnimationClass = (toast?: Toast): string | undefined => {
    if (toast?.options?.animation) {
        if (toast?.isLeaving) {
            return 'animate-toast-slide-out-mobile tablet:animate-toast-slide-out-desktop';
        }
        return 'animate-toast-slide-in-mobile tablet:animate-toast-slide-in-desktop';
    }
};

export const useToastContainer = (isMobile: boolean) => {
    const { isOpen, modalIdInView } = useModalState();
    if (typeof window === 'undefined') {
        return null;
    }

    if (isOpen && modalIdInView) {
        return document.getElementById(modalIdInView);
    }

    if (isMobile) {
        return document.getElementsByTagName(MAIN_TAG)?.[0];
    }

    return document.getElementById(FIXED_HEADER_ID);
};

export const useToastContainerStyle = (isMobile: boolean, toastOptions?: Toast['options']) => {
    const {
        header: { headerHeight },
    } = useLayoutStateContext();
    const { isOpen: isModalOpen } = useModalState();

    const {
        fixedAddToBasket: { fixedAddToBasketVisible, fixedAddToBasketHeight },
    } = useLayoutStateContext();

    if (isModalOpen) {
        if (isMobile) {
            if (toastOptions?.hasModalFooter) {
                return {
                    classNames: 'bottom-[5rem]',
                };
            }
            return {
                classNames: 'bottom-0',
            };
        }

        return {
            classNames: '!w-full top-headerFixedNavDesktop tablet:max-w-full desktop:max-w-full',
        };
    }

    if (isMobile) {
        if (fixedAddToBasketVisible) {
            return {
                bottom: `${fixedAddToBasketHeight}px`,
            };
        }

        return {
            clasNammes: `bottom-0`,
        };
    }

    return {
        top: headerHeight,
    };
};

export const useToastContainerPositioning = (toast?: Toast) => {
    const isMobile = useTailwindBreakpoint('tablet', false, true);

    const { classNames, ...style } = useToastContainerStyle(isMobile, toast?.options);
    const container = useToastContainer(isMobile);

    return {
        style,
        container,
        zIndex: isMobile ? 'z-toastMobile' : 'z-toast',
        classNames,
        animationClass: getToastAnimationClass(toast),
    };
};
